import { createAction } from 'redux-actions'

const SET_GROUPS = 'SET_GROUPS'
const SET_URL = 'SET_URL'

const setGroups = createAction(SET_GROUPS)
const setUrl = createAction(SET_URL)

export { setGroups, setUrl }
